import { useEffect, useRef, useState } from 'react'

export function useComponentVisible<T>(initialIsVisible: boolean) {
  const [isVisible, setIsVisibleUpdater] = useState(initialIsVisible)
  const [lastUpdated, setLastUpdated] = useState(Date.now())

  const componentRef = useRef<T & HTMLElement>(null)

  const setIsVisible = (visible: boolean) => {
    const updateTime = Date.now()

    if (updateTime - lastUpdated > 100) {
      setIsVisibleUpdater(visible)
      setLastUpdated(updateTime)
    }
  }

  const handleClickOutside = (event: MouseEvent) => {
    const target = event.target as Element
    const clickIsInside = componentRef.current?.contains(target)

    // Check if click occurs on a portal-element (a popover for instance)
    const isPortal = event.target && target.closest('.portal') ? true : false

    if (!clickIsInside && isVisible && !isPortal) {
      setIsVisible(false)
    }
  }

  const handleKeyboardInput = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      setIsVisible(false)
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true)
    document.addEventListener('keydown', handleKeyboardInput, true)
    return () => {
      document.removeEventListener('click', handleClickOutside, true)
      document.removeEventListener('keydown', handleKeyboardInput, true)
    }
  })

  return { componentRef, isVisible, setIsVisible }
}
